import * as Sentry from '@sentry/browser';

const handleError = (err) => {
  Sentry.captureException(err);
};

export { handleError };
